<div
  class="popup"
  [class.is-open]="open()"
  role="dialog"
  aria-modal="true"
  aria-labelledby="finder-title"
  [attr.aria-hidden]="!open()"
>
  <div class="popup__backdrop" (click)="popups.close()"></div>

  <div class="popup__dialog finder">
    <button type="button" class="popup__close" aria-label="Close recliner finder" (click)="popups.close()">&times;</button>

    <div class="finder__head">
      <span class="finder__eyebrow">{{ head().eyebrow }}</span>
      <h2 class="finder__title" id="finder-title">{{ head().title }}</h2>
      <div class="progress">
        <div class="progress__bar"><span [style.width.%]="progress()"></span></div>
        <span class="progress__count" aria-live="polite">{{ count() }} of {{ total }}</span>
      </div>
    </div>

    <div class="finder__body" #body>
      @if (question(); as q) {
        <!-- (the question itself is the dialog's title) -->
        <p class="finder__hint">{{ q.hint }}</p>
        <fieldset class="options">
          <legend class="sr-only">{{ q.title }}</legend>
          @for (o of q.options; track o.value) {
            <label class="option">
              <input
                type="radio"
                [name]="'finder-' + q.id"
                [value]="o.value"
                [checked]="answers()[q.id] === o.value"
                (change)="choose(q.id, o.value)"
              />
              <span class="option__box">
                @if (o.seats; as seats) {
                  <span class="option__icon">
                    <svg viewBox="0 0 36 22" width="26" height="17" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
                      <path [attr.d]="sofa + seams[seats]" />
                      <rect x="1.6" y="12" width="32.8" height="7" rx="2.4" />
                    </svg>
                  </span>
                }
                <span>
                  {{ o.label }}
                  @if (o.note) {
                    <br /><small>{{ o.note }}</small>
                  }
                </span>
              </span>
            </label>
          }
        </fieldset>
      } @else if (step() === 0) {
        <div class="intro">
          <div class="intro__chair" aria-hidden="true">🪑</div>
          <h3>Five quick questions</h3>
          <p>
            Tell us how you will use it and we will shortlist the recliners that fit. Takes under a minute, and you can
            skip any question.
          </p>
        </div>
      } @else {
        <p class="finder__why">{{ reason() }}</p>
        <div class="cards">
          @for (p of picks(); track p.name) {
            <div class="card">
              <a class="card__thumb" [href]="p.href" target="_blank" rel="noopener">
                <img [src]="p.image" [alt]="p.name" loading="lazy" decoding="async" />
              </a>
              <div class="card__info">
                <span class="card__category">{{ p.category }}</span>
                <span class="card__name">{{ p.name }}</span>
                <span class="card__price">{{ p.price }}</span>
                <a class="card__go" [href]="p.href" target="_blank" rel="noopener" [attr.aria-label]="'View range: ' + p.name">
                  View range
                </a>
              </div>
            </div>
          }
        </div>
        <p class="finder__note">Prices shown are indicative. Final price depends on size, upholstery and configuration.</p>
      }
    </div>

    <div class="finder__foot">
      @if (question(); as q) {
        <button type="button" class="finder__btn finder__btn--ghost" (click)="go(step() - 1)">Back</button>
        <span class="finder__gap"></span>
        <button type="button" class="finder__btn finder__btn--link" (click)="skip(q.id)">Skip</button>
        <button type="button" class="finder__btn finder__btn--primary" [disabled]="!answers()[q.id]" (click)="go(step() + 1)">
          {{ step() === total ? 'See results' : 'Next' }}
        </button>
      } @else if (step() === 0) {
        <button type="button" class="finder__btn finder__btn--link" (click)="popups.close()">Not now</button>
        <span class="finder__gap"></span>
        <button type="button" class="finder__btn finder__btn--primary" (click)="go(1)">Start</button>
      } @else {
        <button type="button" class="finder__btn finder__btn--ghost" (click)="restart()">Start over</button>
        <span class="finder__gap"></span>
        <button type="button" class="finder__btn finder__btn--link" (click)="expert()">Talk to an expert</button>
        <button type="button" class="finder__btn finder__btn--primary" (click)="popups.close()">Done</button>
      }
    </div>
  </div>
</div>
